import React from 'react';
import { Button, Image } from 'antd';
import Config from '../../../config/Config';
import { EMPTY_TEXT, formatMonthRange } from '../utils/resumeTransforms';

const filePath = Config.getFilePath();

const value = (text) => (text !== undefined && text !== null && text !== '' ? text : EMPTY_TEXT);

const renderWork = (item) => (
  <div className="resume-new-record-grid">
    <div><label>公司名称：</label>{value(item.ENTNAME)}</div>
    <div><label>职位类型：</label>{value(item.JOBTYPE_CN)}</div>
    <div><label>职位名称：</label>{value(item.POSITION)}</div>
    <div><label>在职时间：</label>{formatMonthRange(item.OCCFROM, item.OCCTO)}</div>
    <div><label>当前月薪：</label>{item.SAL ? `${item.SAL}元` : EMPTY_TEXT}</div>
    <div className="resume-new-record-full"><label>工作描述：</label>{value(item.DETAIL)}</div>
  </div>
);

const renderEducation = (item) => (
  <div className="resume-new-record-line">
    <span>{value(item.EDU_CN)}</span>
    <span>{value(item.SCHOOL)}{item.MAJOR ? `（${item.MAJOR}）` : ''}</span>
    <span>{formatMonthRange(item.ENRFROM, item.ENRTO)}</span>
  </div>
);

const renderSkill = (item) => <div className="resume-new-record-line"><span>{value(item.SKLNAME)}</span><span>{value(item.PROFLVL_CN)}</span></div>;
const renderLanguage = (item) => <div className="resume-new-record-line"><span>{value(item.LANGUAGE_CN)}</span><span>听说能力：{value(item.SPEAKING_CN)}</span><span>读写能力：{value(item.LITERACY_CN)}</span></div>;

const renderCertificate = (item, applicantId) => (
  <div className="resume-new-record-line is-start">
    {item.attachments && item.attachments.length > 0 ? <Image width={75} src={`${filePath}applicant/${applicantId}/L${item.attachments[0]}.png`} /> : <span>暂无证书附件</span>}
    <span>{value(item.CERTNAME)}</span>
  </div>
);

const renderWorks = (item, applicantId) => (
  <div>
    <div className="resume-new-record-line"><span>作品名称：{value(item.WORKSNAME)}</span></div>
    <div className="resume-new-work-images">
      {(item.attachments || []).map((attachment) => <Image key={attachment} width={75} src={`${filePath}applicant/${applicantId}/L${attachment}.png`} />)}
    </div>
  </div>
);

const renderRecord = (section, item, applicantId) => {
  if (section.id === 'workHistory') return renderWork(item);
  if (section.id === 'EdcHistory') return renderEducation(item);
  if (section.id === 'jobSkill') return renderSkill(item);
  if (section.id === 'language') return renderLanguage(item);
  if (section.id === 'certificate') return renderCertificate(item, applicantId);
  if (section.id === 'works') return renderWorks(item, applicantId);
  return null;
};

const ResumeListSection = ({ section, list = [], applicantId, onEdit, onDelete }) => {
  if (!list.length) {
    return <div className="resume-new-empty">暂无{section.title}，点击添加完善信息</div>;
  }

  return (
    <div className="resume-new-record-list">
      {list.map((item, index) => (
        <div className="resume-new-record" key={item.id || index}>
          <div className="resume-new-record-content">{renderRecord(section, item, applicantId)}</div>
          <div className="resume-new-record-actions">
            <Button type="link" onClick={() => onEdit(index, item)}>编辑</Button>
            <Button type="link" danger onClick={() => onDelete(item)}>删除</Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResumeListSection;
